import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";

@staticImplements<ResponseModelInterfaceStatic>()
export class StdAprioriValue
{
    public constructor(
        public standardValue: number,
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): StdAprioriValue
    {
        // Here we only extract the "stdandardValue", the "Operation" tag don't need to be implemented client-side.
        return new this(
            elem.firstChildByTag("standardValue").valueAsNumber()
        );
    }

    static makeFromStandardValue(value: number) : StdAprioriValue
    {
        return new this(value);
    }

    /**
     * This getter allows to retrieve the computed apriori value.
     * Actually this value only directly returns the standardValue, but we may
     * in the future have to evaluate a dynamic "Operation".
     */
    public get value() : number
    {
        return this.standardValue;
    }
}
